import React from 'react';
import Navbar from './Navbar';
import ConsultationForm from './ConsultationForm';
import FooterSection from './FooterSection';
import ContactSection from './ContactSection';
import bannerImage from '../assets/img/contact_banner.png';
import './Contact.css';  // Import the contact CSS file
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';  // Import Font Awesome icons

const Contact = () => {
  return (
    <div className="contact-page"> {/* Added wrapper for background color */}
      <Navbar />

      {/* Contact Banner Section with img tag */}
      <section className="contact-banner d-flex justify-content-center align-items-center text-center">
        <img src={bannerImage} alt="Contact Banner" className="banner-image" />
        <div className="text-start">
          <h1 className="text-black montserrat-heading mb-2">Get in Touch with Us</h1> {/* Montserrat applied */}
          {/* <div className="gradient-line"></div> */}
          <p className="text-black poppins-text mt-4">
            Have questions about Breast Infrared? Our team is here to help. Reach out today!
          </p> {/* Poppins applied */}
        </div>
      </section>
       {/* Contact Details Section */}
      
       <ContactSection />

      {/* Email Support Section */}
      {/* <div className="container email my-5">
        <div className="card text-center p-4">
          <h4 className="montserrat-heading">Email Support</h4> 
          <p className="poppins-text">Your direct line to efficient problem-solving, at your convenience.</p> 
          <button className="btn gradient-btn email-btn">
            <a
              href="mailto:support@breastshield.com"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              <i className="fas fa-envelope"></i> 
              Send Email →
            </a>
          </button>
        </div>
      </div> */}

      {/* Consultation Form Section */}
      <ConsultationForm />

     
      <FooterSection />
    </div>
  );
};

export default Contact;
